<template>
  <b-container fluid class="animated fadeIn">
    <div class="d-flex align-items-center">
      <b-col>
        <h1 class="app-title mt-4">
          Cadastro de Palavra-Chave
        </h1>
      </b-col>
    </div>
    <b-card>
      <b-form>
        <b-alert variant="danger" :show="msgErroFormulario">
          {{ msgErroFormulario }}
        </b-alert>
        <b-row>
          <b-col md="10">
            <b-form-group
              id="groupNome"
              label="Palavra-chave:"
              label-for="nome"
            >
              <b-form-input
                maxlength="80"
                id="nome"
                name="nome"
                v-model="filtro.palavra"
                type="text"
                required
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group
              id="groupCor"
              label="Código Hexadecimal (Ex.:#FFFFFF):"
              label-for="cor"
            >
              <b-form-input
                maxlength="80"
                id="cor"
                name="cor"
                v-model="filtro.cor"
                type="text"
                required
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col xs="4" sm="4" md="4" lg="4" xl="4">
            <b-form-group
              label="Situação:"
              label-for="situacao"
              class="text-label"
            >
              <b-form-radio-group
                id="radio-group-1"
                v-model="filtro.situacao"
                :options="situacao.options"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-between">
            <div>
              <b-button
                variant="primary"
                class="fonte-branca ml-1"
                @click="filtrar"
              >
                <i class="fa fa-search"></i> Pesquisar
              </b-button>
              <b-button
                variant="primary"
                @click.prevent="openIncluir"
                class="fonte-branca ml-1"
              >
                <i class="fa fa-plus"></i> Incluir
              </b-button>
              <b-button
                variant="primary"
                class="fonte-branca ml-1"
                @click.prevent="openAlterar"
                :disabled="selecionados.length !== 1"
              >
                <i class="fa fa-pencil"></i> Alterar
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-modal
        @show="resetModal"
        size="lg"
        ref="modalPalavraChave"
        id="modal-center"
        scrollable
        centered
        header-bg-variant="primary"
        header-text-variant="white"
        :title="titleModal"
        footer-class="d-flex justify-content-center align-items-center"
      >
        <label class="float-right">(*) campo obrigatório</label>
        <b-form>
          <b-alert variant="danger" :show="msgErroFormulario">
            {{ msgErroFormulario }}
          </b-alert>
          <b-form-group id="groupPalavraChave" label="Descrição: *" label-for="palavraChave">
            <b-form-input
              maxlength="80"
              id="palavraChave"
              name="palavraChave"
              v-validate="{ required: true, max: 80 }"
              v-model="palavraChave.palavra"
              type="text"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="groupCor"
            label="Código Hexadecimal (Ex.:#FFFFFF): *"
            label-for="cor"
          >

            <b-form-input
              id="cor"
              name="cor"
              v-validate="{ required: true, min:7, max:7, regex: /^#[0-9A-F]{6}$/i}"
              v-model="palavraChave.cor"
              type="text"
              maxlenght="6"
              minlenght="6"
              :state="validaCor(palavraChave.cor)"
              required
            >
            </b-form-input>
          </b-form-group>
          <template v-if="indAlterar">
            <b-form-group
              label="Situação: *"
              label-for="radio-group-edit-situacao"
            >
              <b-form-radio-group
                id="radio-group-edit-situacao"
                v-model="palavraChave.indAtivo"
                name="radio-edit-situacao"
              >
                <b-form-radio value="1">Ativo</b-form-radio>
                <b-form-radio value="0">Inativo</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </template>
        </b-form>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="salvar"
            :disabled="inSave"
          >
            <i class="fa fa-save"></i> Salvar
          </b-button>
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="cancel()"
          >
            <i class="fa fa-reply"></i> Voltar
          </b-button>
        </template>
      </b-modal>

      <b-row class="mt-3">
        <b-col xs="12" md="12" class="mx-auto">
          <b-col xs="12">
            <div>
              <b-row class="d-flex justify-content-between">
                <b-col>
                  <label class="mt-3">
                    Palavras - Quantidade: <strong>{{ items.length }}</strong>
                  </label>
                </b-col>
                <b-col>
                  <CompPaginacao :configTable="configTable" />
                </b-col>
              </b-row>
              <b-table
                :no-border-collapse="false"
                striped hover bordered responsive small
                :perPage="configTable.perPage"
                :currentPage="configTable.currentPage"
                :sort-by="configTable.sortField"
                :sort-desc="false"
                :items="items"
                :busy="configTable.load"
                :fields="fieldsPalavraChave"
                class="mb-0"
                head-variant="light"
                show-empty
              >
                <template slot="empty">
                    <p class="my-auto">Nenhum Palavra-Chave encontrada.</p>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>Carregando...</strong>
                  </div>
                </template>
                <template slot="selecao" slot-scope="row">
                  <b-form-checkbox
                    v-model="row.item.selecao"
                    name="checkbox-1"
                    :unchecked-value="false"
                    :value="true"
                    @input="selecionar(row.item)"
                    :disabled="row.item.erro"
                  >
                  </b-form-checkbox>
                </template>

                <template slot="palavra" slot-scope="row">
                  <div>
                    {{ row.item.palavra }}
                  </div>
                </template>

                <template slot="cor" slot-scope="row">
                  <div :style="{color: row.item.cor}">
                    {{ row.item.cor }}
                  </div>
                </template>

                <template slot="indAtivo" slot-scope="row">
                  <div>
                    {{ row.item.indAtivo ? 'Ativo' : 'Inativo' }}
                  </div>
                </template>
              </b-table>

              <b-row class="d-flex justify-content-between">
                <b-col style="background: #F0F3F5;" class="mx-3">
                  <div style="float: right;">
                    Total linhas: {{ getTotalInPage() }}
                  </div>
                </b-col>
              </b-row>

              <b-row class="d-flex justify-content-between mt-3">
                <b-col></b-col>
                <b-col>
                  <CompPaginacao :configTable="configTable" />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import axios from "axios";
import CompPaginacao from "../components/CompPaginacao";

const urlApi = process.env.VUE_APP_ROOT_API;

export default {
  name: "TabelaPalavraChave",
  components: {
    CompPaginacao,
  },
  data() {
    return {
      situacao: {
        selected: "todos",
        options: [
          { text: "Todos", value: "todos" },
          { text: "Ativo", value: "ativo" },
          { text: "Inativo", value: "inativo" },
        ],
      },
      items: [],
      fieldsPalavraChave: [
        {
          key: "selecao",
          sortable: false,
          label: "Sel.",
          thStyle: {
            width: "40px"
          }
        },
        {
          key: "palavra", 
          sortable: true,
          label: "Palavra-chave",
        },
        {
          key: "cor",
          sortable: true,
          label: "Código Hexadecimal",
        },
        {
          key: "indAtivo",
          sortable: true,
          label: "Situação",
          thStyle: {
            width: "200px"
          }
        },
      ],
      selecionados: [],
      configTable: {
        perPage: 100,
        sortField: "palavra",
        currentPage: 1,
        rows: 0,
        checkedAll: false,
        load: false,
      },
      filtro: {
        palavra: null,
        cor: null,
        situacao: 'todos',
      },
      palavraChave: {
        id: null,
        palavra: null,
        cor: null,
        indAtivo: true
      },
      indAlterar: false,
      inSave: false,
      msgErroFormulario: null,
      titleModal: "Incluir",
    };
  },
  methods: {
    /**
     * Consultar divídas
     */
     async consultar() {
      this.loadingEnter();
      const token = JSON.parse(this.$store.getters.getUser).access_token;

      const params = {
        ...this.filtro
      }
      axios.get(`${urlApi}/v1/palavrachave/consulta`, {
          params: params,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        })
        .then((response) => {
          const data = response.data
          this.items = data
          this.configTable.rows = data.length
        })
        .catch((error) => {
          error
        })
        .finally(() => {
          this.loadingExit();
        });
    },
    selecionar(item) {
      if (item.selecao) {
        if (!this.selecionados.includes(item)) {
          this.selecionados.push(item);
        }
      } else {
        const index = this.selecionados.indexOf(item);
        if (index > -1) { 
          this.selecionados.splice(index, 1);
        }
      }
    },
    /**
     * Filtrar a consulta
     */
     filtrar() {
      this.configTable.currentPage = 1;
      this.configTable.rows = 0;
      this.configTable.checkedAll = false;
      this.resultado = [];
      this.selecionados = [];
      this.consultar();
    },
    resetModal() {
      (this.palavraChave = {
        id: null,
        palavra: null,
        cor: null,
        indAtivo: true,
      }),
        (this.msgErroFormulario = null);
    },
    validaCor(cor) {
      if (cor == null) {
        return
      }

      if (!cor || cor.length != 7) {
        return false;
      }
      let result = /^#[0-9A-F]{6}$/i.test(cor)
      if (!result) {
        this.msgErroFormulario = "Cor inválida"
      } else if (this.msgErroFormulario != 'Favor preencher os campos obrigatórios (*)') {
        this.msgErroFormulario = null;
      }
      return result;
    },
    /**
     * Salvar
     */
    async salvar(evt) {
      evt.preventDefault();
      this.inSave = true;
      this.msgErroFormulario = null;

      this.$validator.validateAll().then(async (result) => {
        if (!result) {
          this.msgErroFormulario = "Favor preencher os campos obrigatórios (*)";
          this.inSave = false;
          return;
        }

        const pchaveSave = {
          id: this.palavraChave.id,
          palavra: this.palavraChave.palavra,
          cor: this.palavraChave.cor,
          indAtivo: this.palavraChave.indAtivo == 0 ? false : true,
        };

        if (this.indAlterar) {
          await this.alterar(pchaveSave)
        } else {
          await this.incluir(pchaveSave)
        }
      });
      this.inSave = false;
    },
    async incluir(pchaveSave) {
      const token = JSON.parse(this.$store.getters.getUser).access_token;
      await axios
          .post(`${urlApi}/v1/palavrachave`, pchaveSave, {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          })
          .then((response) => {
            if (response.data) {
              this.msgErroFormulario = `${response.data.message}`;
              return;
            }
            this.$store.commit("setMessages", {
              message: "Sucesso",
              variant: "success",
              errors: ["Operação realizada com sucesso!!!"],
            });
            this.$refs["modalPalavraChave"].hide();
            this.selecionados = [];
            this.consultar();
          })
          .catch((error) => {
            this.exibirErro(error);
          })
          .finally(() => {
            this.inSave = false;
          });
    },
    async alterar(pchaveSave) {
      const token = JSON.parse(this.$store.getters.getUser).access_token;
      await axios
          .put(`${urlApi}/v1/palavrachave/${pchaveSave.id}`, pchaveSave, {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          })
          .then((response) => {
            if (response.data) {
              this.msgErroFormulario = `${response.data.message}`;
              return;
            }
            this.$store.commit("setMessages", {
              message: "Sucesso",
              variant: "success",
              errors: ["Operação realizada com sucesso!!!"],
            });
            this.$refs["modalPalavraChave"].hide();
            this.selecionados = [];
            this.consultar();
          })
          .catch((error) => {
            this.exibirErro(error);
          })
          .finally(() => {
            this.inSave = false;
          });
    },
    /**
     * Incluir
     */
    openIncluir(evt) {
      evt.preventDefault();
      this.indAlterar = false;
      this.$refs["modalPalavraChave"].show();
      this.titleModal = "Incluir Palavra-chave";
    },

    /**
     * Alterar
     */
     openAlterar(evt) {
      evt.preventDefault();
      if (!this.selecionados[0]) {
        return;
      }
      this.indAlterar = true;
      this.$refs["modalPalavraChave"].show();
      this.titleModal = "Alterar";
      const {
        id,
        palavra,
        cor,
        indAtivo,
      } = this.selecionados[0];
      this.palavraChave.id = id;
      this.palavraChave.palavra = palavra;
      this.palavraChave.cor = cor;
      this.palavraChave.indAtivo = indAtivo ? 1 : 0;
    },
    /**
     * Exibe erros dos catch
     */
    exibirErro(error) {
      this.$store.commit("setMessages", { message: "Erro!", errors: [error] });
    },

    /**
     * Controle do Loading da Tabela
     */
    loadingEnter() {
      this.configTable.load = true;
    },

    /**
     * Controle do Loading da Tabela
     */
    loadingExit() {
      this.configTable.load = false;
    },

    getTotalInPage() {
      if (this.configTable.rows < this.configTable.perPage) {
        return this.configTable.rows
      } else {
        const qtdPg = this.configTable.rows / this.configTable.perPage

        if (this.configTable.currentPage < qtdPg) return this.configTable.perPage

        return this.configTable.rows - (this.configTable.perPage * (this.configTable.currentPage - 1))
      }
    }
  },
  watch: {
    perPage() {
      this.configTable.currentPage = 1;
      this.consultar();
    },
  },
  computed: {
    perPage() {
      return this.configTable.perPage;
    },
  },
  mounted() {
    this.$store.commit("setMessages", {});

    this.consultar();
  },
};
</script>

<style scoped></style>
